import { render, staticRenderFns } from "./SongkranMemory.vue?vue&type=template&id=9f9b220e&scoped=true&"
import script from "./SongkranMemory.vue?vue&type=script&lang=js&"
export * from "./SongkranMemory.vue?vue&type=script&lang=js&"
import style0 from "./SongkranMemory.vue?vue&type=style&index=0&id=9f9b220e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9b220e",
  null
  
)

export default component.exports